import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { GA_MEASUREMENT_ID, GA_ENABLED } from './utils/ga';

if (GA_ENABLED && typeof window !== 'undefined' && navigator.userAgent !== 'ReactSnap') {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

// Setup for react-snap prerendering
const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // If the app is being hydrated by react-snap
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  // Normal render for development and fresh loads
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
